/**
 * Datadog Component
 *
 * This React component integrates Datadog RUM (Real User Monitoring) into the MFE Container App.
 * It dynamically adds the Datadog RUM script to the document head when the component is mounted.
 *
 * Environment variables used: (Environment variables are set in the Github repo secrets and variables)
 * - `DEPLOYMENT_ENV`: The deployment environment (e.g., 'dev', 'qual', 'prod').
 * - `DD_CLIENT_TOKEN`: The Datadog client token.
 * - `DD_APPLICATION_ID`: The Datadog application ID.
 * - `APP_VERSION`: The application version.
 *
 * Configuration settings:
 * - `clientToken`: The Datadog client token.
 * - `applicationId`: The Datadog application ID.
 * - `site`: The Datadog site (default is 'datadoghq.com').
 * - `service`: The service name ('jd-warranty-container-app').
 * - `env`: The deployment environment.
 * - `version`: The application version.
 * - `sessionSampleRate`: The session sample rate (100% for both prod and non-prod).
 * - `sessionReplaySampleRate`: The session replay sample rate (100% for prod, 20% for non-prod).
 * - `trackUserInteractions`: Whether to track user interactions (true).
 * - `trackResources`: Whether to track resources (true).
 * - `trackLongTasks`: Whether to track long tasks (true).
 * - `defaultPrivacyLevel`: The default privacy level ('allow').
 *
 * @component
 * @example
 * return (
 *   <Datadog />
 * )
 */

import React, { useEffect } from 'react'

const Datadog = () => {

    useEffect(() => {
            addScript()
    }, [])

    const addScript = () => {

        const datadogClientToken = process.env.REACT_APP_DD_CLIENT_TOKEN || ''
        const datadogApplicationId = process.env.REACT_APP_DD_APPLICATION_ID || ''
        const datadogEnv = process.env.REACT_APP_DEPLOYMENT_ENV || ''
        const appVersion = process.env.APP_VERSION || '1.0.0'

        const scriptDD = document.createElement('script')

        scriptDD.text = `
            (function(h,o,u,n,d) {
                h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}
                d=o.createElement(u);d.async=1;d.src=n
                n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)
            })(window,document,'script','https://www.datadoghq-browser-agent.com/us1/v5/datadog-rum.js','DD_RUM')
            window.DD_RUM.onReady(function() {
                window.DD_RUM.init({
                    clientToken: '${datadogClientToken}',
                    applicationId: '${datadogApplicationId}',
                    site: 'datadoghq.com',
                    service: 'jd-warranty-container-app',
                    env: '${datadogEnv}',
                    version: '${appVersion}',
                    sessionSampleRate: ${100},
                    sessionReplaySampleRate: ${100},
                    trackUserInteractions: true,
                    trackResources: true,
                    trackLongTasks: true,
                    defaultPrivacyLevel: 'allow'
                });
            })
        `

        document.head.appendChild(scriptDD)

    }

    return (
        <div>

        </div>
    )
}

export default Datadog